(() => {
  function formCirclesAnimation() {
    const circleContainer = document.getElementById('form__circle-container');
    if (!circleContainer) return;

    const mm = gsap.matchMedia();
    const breakpoint = 1024;

    function tweenProperty(target, prop, min, max) {
      const randomDur = gsap.utils.random(3, 6, 0.2, true);
      const randomDelay = gsap.utils.random(0.6, 2, 0.2, true);
      const randomVal = gsap.utils.random(min, max);

      gsap.to(target, {
        [prop]: randomVal,
        duration: randomDur(),
        delay: randomDelay(),
        ease: 'none',
        onComplete: tweenProperty,
        onCompleteParams: [target, prop, min, max],
      });
    }

    mm.add({
      isDesktop: `(min-width: ${breakpoint}px)`,
      isMobile: `(max-width: ${breakpoint - 1}px)`,
      reduceMotion: '(prefers-reduced-motion: reduce)',
    }, (context) => {
      const { isDesktop, reduceMotion } = context.conditions;
      if (!reduceMotion && isDesktop) {
        gsap.utils.toArray('.form-circle').forEach((circle) => {
          tweenProperty(circle, 'xPercent', -15, 15);
          tweenProperty(circle, 'yPercent', -15, 15);
        });
      }
    });
  }

  function init() {
    formCirclesAnimation();
  }
  document.addEventListener('DOMContentLoaded', init, false);
})();
